import { gql, useApolloClient, useLazyQuery } from "@apollo/client";

const DOCPRODUCER_TASKS_QUERY = gql`
  query GetDocProducerDocuments($taskId: String) {
    tasks(filter: $taskId, Type: ALL_COMPLETED_TASKS_TODAY) {
      taskId
      category
      description
      attachments
      reference
      createDate
    }
  }
`;

const DOCPRODUCER_ALL_TASKS_QUERY = gql`
  query GetDocProducerAllTasks($taskId: String) {
    tasks(filter: $taskId, Type: ALL_TASKS) {
      title
      taskId
      category
      description
      attachments
      reference
      createDate
    }
  }
`;

export interface ProducedDocumentsTask {
  tasks: Task[];
}

export interface Task {
  title: string;
  taskId: string;
  createDate: string;
  category: string;
  description: string;
  attachments: string[];
  reference: string;
}

export const useGetProducedDocuments = () => {
  const client = useApolloClient();

  const fetchProducedDocuments = async (
    taskId: string,
    useAllTasks = false
  ) => {
    const { data, networkStatus } = await client.query<ProducedDocumentsTask>({
      query: useAllTasks
        ? DOCPRODUCER_ALL_TASKS_QUERY
        : DOCPRODUCER_TASKS_QUERY,
      notifyOnNetworkStatusChange: true,
      variables: {
        taskId,
      },
      fetchPolicy: "network-only",
    });
    return { data, networkStatus };
  };

  return { fetchProducedDocuments };
};
